import Alpine from "alpinejs";
import { ModificationHandler, type ModificationPhase } from "../office/ModificationHandler";
import { onOfficeReady } from "../office/state";

export const modificationHandler = new ModificationHandler()

export const modificationState = Alpine.reactive({ phase: "unregistered" as ModificationPhase });
modificationHandler.onPhaseChange((x) => {
  modificationState.phase = x
})

async function initModificationHandler() {
  await modificationHandler.register(Word.run)
}

onOfficeReady(async (enabled) => {
  if (!enabled) {
    console.log("[modifications-dev] Office not ready");
    return;
  }

  await initModificationHandler();
});
